const comeContattarciOrari = Object.freeze([
  {
    day: 'Lunedì',
    from: '8',
    to: '18',
  },
  {
    day: 'Martedì',
    from: '8',
    to: '18',
  },
  {
    day: 'Mercoledì',
    from: '8',
    to: '18',
  },
  {
    day: 'Giovedì',
    from: '8',
    to: '18',
  },
  {
    day: 'Venerdì',
    from: '8',
    to: '18',
  },
  {
    day: 'Sabato',
    from: '8',
    to: '18',
  },
]);

export const dataDefault = Object.freeze({
  number: '020202 - tasto 4.1.3',
  timetables: comeContattarciOrari,
  link: 'https://servizicrm.comune.milano.it/Wemi/Richiestecomplesse',
  andress: 'Via Sammartini, 75',
  transport: '20133 Milano (M2 Lambrate - Bus 54)'
});

export const color = 'purple';